import React from "react";
import { Dialog } from "primereact/dialog";
import "./KeyboardShortcutsModal.css";

const KeyboardShortcutsModal = ({ visible, onHide }) => {
  // Detect platform for keyboard shortcuts display
  const modKey = navigator.platform.includes("Mac") ? "⌘" : "Ctrl";

  const shortcuts = [
    {
      category: "Navegação de Abas",
      items: [
        {
          keys: `${modKey}+1 até ${modKey}+9`,
          description: "Alternar entre as primeiras 9 abas",
        },
        { keys: `${modKey}+0`, description: "Alternar para a 10ª aba" },
      ],
    },
    {
      category: "Painéis e Barras",
      items: [
        {
          keys: `${modKey}+I`,
          description: "Abrir/Fechar dropdown de Indicadores",
        },
        {
          keys: `${modKey}+D`,
          description: "Mostrar/Ocultar barra de Desenhos (esquerda)",
        },
        {
          keys: `${modKey}+L`,
          description: "Mostrar/Ocultar painel de Ordens (esquerda)",
        },
        {
          keys: `${modKey}+R`,
          description: "Mostrar/Ocultar barra de Negociação (direita)",
        },
        {
          keys: `${modKey}+J`,
          description: "Mostrar/Ocultar painel de Logs (inferior)",
        },
      ],
    },
    {
      category: "Visualização",
      items: [
        {
          keys: "F11",
          description: "Tela cheia (ocultar barra de endereço e favoritos)",
        },
      ],
    },
    {
      category: "Ajuda",
      items: [
        {
          keys: `${modKey}+Shift+/`,
          description: `Abrir esta janela de atalhos (ou ${modKey}+?)`,
        },
      ],
    },
  ];

  return (
    <Dialog
      header="Atalhos de Teclado"
      visible={visible}
      onHide={onHide}
      style={{ width: "600px" }}
      modal
      dismissableMask
      className="keyboard-shortcuts-modal"
    >
      <div className="shortcuts-content">
        {shortcuts.map((section, idx) => (
          <div key={idx} className="shortcuts-section">
            <h3 className="shortcuts-category">{section.category}</h3>
            <div className="shortcuts-list">
              {section.items.map((item, itemIdx) => (
                <div key={itemIdx} className="shortcut-item">
                  <div className="shortcut-keys">
                    <kbd>{item.keys}</kbd>
                  </div>
                  <div className="shortcut-description">{item.description}</div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </Dialog>
  );
};

export default KeyboardShortcutsModal;
